export default __webpack_public_path__ + "static/media/23.f68ab45f.png";